import { Field, ObjectType } from '@nestjs/graphql'
import { IdDto } from '../../base'

@ObjectType()
export class BaseThreadUserDto extends IdDto {
  @Field({ nullable: true })
  modelKey?: string

  @Field({ nullable: true })
  name?: string

  @Field({ nullable: true })
  image?: string

  @Field()
  existingThreadCount!: number
}
